import type { FieldDefinition } from "../fields.js";

export function getFields(
	fields: null | Array<string | FieldDefinition> | string,
	defaultNullable = true,
): FieldDefinition[] {
	if (fields === null) {
		return [];
	} else if (Array.isArray(fields)) {
		return fields.map((field) => {
			if (typeof field === "object") {
				return field;
			} else {
				return { name: field, nullable: defaultNullable } as FieldDefinition;
			}
		});
	} else if (typeof fields === "string") {
		return [{ name: fields }];
	}

	return fields;
}
